module.exports = __webpack_public_path__ + "img/Ellipse122.fe795413.png";